import type { ReactNode } from 'react';

/**
 * Grey bars where content is about to be, instead of a spinner and a word: the
 * page keeps its shape while it loads, so nothing jumps when the data arrives.
 * A screen reader still hears "Loading…", and stops hearing it when it is gone.
 */
export function Loading({ lines = 3 }: { lines?: number }): ReactNode {
  return (
    <div className="skeleton-stack" role="status" aria-busy="true">
      <span className="visually-hidden">Loading…</span>
      {Array.from({ length: lines }, (_, index) => (
        <span
          key={index}
          className="skeleton skeleton-line"
          aria-hidden="true"
          style={index === lines - 1 ? { width: '60%' } : undefined}
        />
      ))}
    </div>
  );
}
